import React from "react";
import Chart from "react-apexcharts";
import { StockAreaChartData } from "../MockData";

function Timeseries_chart({ width, height }) {
  

  return (
    <div style={{ width, height }}>
      <Chart
        options={StockAreaChartData.options}
        series={StockAreaChartData.series}
        type="area"
        height={350}
      />
    </div>
  );
}

export default Timeseries_chart;
